/**
* @author ktao 2017-04-07
* 公共参照组件 -- 参照对话框  (单树)
*
*/
<template>
    <div class="base-ref-dialog">
        <el-row>
            <el-col :span="8" style="padding-right: 10px;">
                <el-row>
                    <el-col :span="24" class="search-input" v-if="searchInput">
                        <el-input
                            placeholder="输入关键字进行过滤"
                            icon="search"
                            v-model="filterText"
                            v-on:keyup.enter.native="doSearch"
                            :on-icon-click="doSearch">
                        </el-input>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24" class="tree-data">
                        <el-tree
                            ref="tree"
                            :data="defTreeData"
                            :props="defaultProps"
                            :show-checkbox="false"
                            :check-strictly="checkStrictly"
                            :filter-node-method="filterNode"
                            :node-key="nodeKey"
                            :highlight-current="true"
                            :default-expanded-keys="defaultExpandedKeys"
                            @node-click="handleNodeClick"
                            @check-change="handleCheckChange"
                            @current-change="handleCurrentChange">
                        </el-tree>
                    </el-col>
                </el-row>
            </el-col>
            <el-col :span="16">
                <el-row>
                    <el-col class="search-area" :span="12" :offset="12">
                        <el-input v-model="searchParams.searchValue" icon="search" @click="doTabelSearch"></el-input>
                    </el-col>
                    <el-col>
                        <list-table :border="true" :height="330"
                                    ref="refTreeTable"
                                    :isCalHeight="false"
                                    :columns="columns"
                                    :dataSource="listData.tableDatas"
                                    :mulSelect='mulSelect'
                                    :pagination="pagination"
                                    :highlightCurrentRow="true"
                                    v-on:currentChange="handleTableCurrentChange"
                                    v-on:sizeChange="handleSizeChange"
                                    @currentRowChange="handleRowChange"
                                    @selectionChange="handleSelectionChange"></list-table>
                    </el-col>
                </el-row>
            </el-col>
        </el-row>
        <!-- <el-row class="button-footer">
            <el-col :span="24">
                <el-button type="primary" @click="confirmClick">确 定</el-button>
                <el-button @click="cancelClick">取 消</el-button>
            </el-col>
        </el-row> -->
    </div>
</template>
<script>
    import ListTable from '../../../../components/pub/components/ListTable.vue';
    export default{
        components:{
            ListTable:ListTable
        },
        props:{
            model:Object,
            defTreeData:Array,
            mulSelect:{
                type:Boolean,
                default:false
            },
            checkStrictly:{
                type:Boolean,
                default:false
            },
            crossLevelSelection:{
                type:Boolean,
                default:false
            },
            columns:Array,
            listData:Object,
            value:[Object,Array],
            shopId: String,
        },
        data:function(){
            return{
                searchInput:true,
                filterText:'',
                nodeKey:"id",
                defaultExpandedKeys:[],
                currentSelect:{},
                multipleSelection:[],
                defaultProps:{
                    children: 'children',
                    label: this.model.getRefClassFields().name
                },
                searchParams:{
                    searchValue:'',
                }
            }
        },
        created:function(){

        },
        mounted:function(){

        },
        watch:{
            defTreeData:function(v){
                this.setDefExpandNode(v);
            }
        },
        methods:{
            setDefExpandNode:function(defTreeData){

                if(defTreeData && defTreeData.length>0){
                    // var nodekeys = [];
                    // nodekeys = defTreeData.map((d) => d.id);
                    this.defaultExpandedKeys = defTreeData.map((d) => d.id);;
                }
            },
            filterNode(value, data) {
                if (!value) return true;
                return data[this.defaultProps.label].indexOf(value) !== -1;
            },
            doSearch:function(){
                this.$refs.tree.filter(this.filterText);
            },
            doTabelSearch:function(){
                this.$emit('reLoadTable',this.searchParams);
            },
            handleNodeClick:function(node){
                //this.currentSelect = node;

                var linkProps = this.model.treeLinkProps;
                this.searchParams[linkProps.tablelink] = node[linkProps.treelink];
                this.searchParams.searchValue = '';
                if ( this.shopId ) {
                  this.searchParams.shopId = this.shopId;
                }
                // if(this.crossLevelSelection){
                //     this.searchParams.multipleSelection = this.multipleSelection;
                // }
                this.$emit('reLoadTable',this.searchParams);
            },
            handleCheckChange:function(node){

                //this.multipleSelection = this.$refs.tree.getCheckedNodes(false);
            },
            handleCurrentChange:function(node){

            },
            handleTableCurrentChange:function(row){

                this.listData.pageInfo.pageIndex = row;
                this.$emit('reLoadTable',null,this.listData.pageInfo);
            },
            handleRowChange:function(row){
                this.currentSelect = row;
                this.$emit('input',row);
            },
            handleSizeChange:function(){

            },
            handleSelectionChange:function(val){
                var _self = this;
                // if(_self.crossLevelSelection){
                //     if(val.length>0){
                //         val.forEach(function(item){
                //             _self.multipleSelection.push(item);    
                //         });
                //     }
                // }else{
                    _self.multipleSelection = val;
                // }
                this.$emit('input',_self.multipleSelection);
            },
            /**
            * 设置默认选择表格行
            */
            setCheckedTableRows:function(row){
                var _self = this;
                _self.$nextTick(function(){
                    if(_self.$refs.refTreeTable){
                        _self.$refs.refTreeTable.defaultCheckedRows(row);
                    }
                });
                
            }

            // //确定
            // confirmClick:function(){
          
            //     if((this.mulSelect && (!this.multipleSelection || this.multipleSelection.length==0))
            //         || (!this.mulSelect && !this.currentSelect))
            //     {
            //         return this.$message({
            //             message: '请选择数据',
            //             type: 'info'
            //         });
            //     }
            //     //this.$emit('cancel');
            //     this.$emit('confirm',this.mulSelect?this.multipleSelection:this.currentSelect);
            // },
            // cancelClick:function(){
            //     this.$emit('cancel');
            // },
        },
        computed:{
            pagination:function(){

                return {
                    totalSize: this.listData?this.listData.pageInfo.totalSize:0,
                    currentPage: this.listData?this.listData.pageInfo.pageIndex:0,
                    pageSize:this.listData?this.listData.pageInfo.pageSize:10,
                    position:'right',
                    layout:'total,prev, pager, next, jumper'
                }
            },
        }
    }
</script>
<style>
    .base-ref-dialog .el-row{
        margin-bottom: 5px;
    }

    .base-ref-dialog .el-tree{
        height: 400px;
        overflow: auto;
    }

    .base-ref-dialog .list-table{
        height: 330px;
    }

    .base-ref-dialog .button-footer{
        text-align: center;
    }

    .base-ref-dialog .el-input__inner{
        width: 100% !important;
        height: 36px !important;
        border-radius: 4px !important;
    }

    .el-form-item.is-error .base-ref-dialog .el-input__inner, .el-form-item.is-error .base-ref-dialog .el-textarea__inner{
        border-color: #bfcbd9;
    }


</style>



// WEBPACK FOOTER //
// src/pub/components/baseRef/view/refTreeTablePanel.vue